export default {"src":"/_next/static/media/QUESTIONNAIRE_ICON.b894246d.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};